import React from "react";
import { useLang } from "../../lib/LanguageContext";
import { JOIN_URL } from "../../lib/content";
import { ArrowUpRight } from "lucide-react";

export default function FinalCTA() {
    const { t, isRTL } = useLang();

    return (
        <section
            id="cta"
            className="relative py-20 sm:py-24 md:py-32 border-t border-[color:var(--sau-border)] overflow-hidden"
            data-testid="sau-final-cta"
        >
            <div
                className="absolute inset-0 pointer-events-none"
                style={{
                    background:
                        "radial-gradient(600px 300px at 50% 100%, rgba(102, 227, 255, 0.1), transparent 60%)",
                }}
                aria-hidden
            />
            <div className="relative max-w-5xl mx-auto px-5 sm:px-6 lg:px-10 text-center">
                <span className="inline-flex items-center gap-2 sau-badge rounded-full px-3.5 h-8 text-[10px] sm:text-[11px] uppercase tracking-[0.22em] sm:tracking-[0.24em]">
                    <span className="sau-badge-dot" />
                    {t.cta.eyebrow}
                </span>
                <h2
                    className="sau-reveal mt-5 sm:mt-6 font-semibold tracking-tight sau-glow-text"
                    style={{
                        fontSize: "clamp(1.75rem, 4.5vw, 3.75rem)",
                        lineHeight: 1.05,
                        letterSpacing: "-0.02em",
                    }}
                >
                    {t.cta.title}
                </h2>
                <p className="sau-reveal mt-5 sm:mt-6 text-[15px] sm:text-base md:text-lg text-[color:var(--sau-text-2)] leading-relaxed max-w-2xl mx-auto">
                    {t.cta.body}
                </p>

                <div className="sau-reveal mt-8 sm:mt-10 flex flex-col sm:flex-row items-stretch sm:items-center justify-center gap-3">
                    <a
                        href={JOIN_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="group inline-flex items-center justify-center gap-2 h-12 px-7 rounded-full sau-btn-primary text-sm font-semibold tracking-wide w-full sm:w-auto"
                        data-testid="sau-cta-primary"
                    >
                        {t.cta.primary}
                        <ArrowUpRight
                            className={`w-4 h-4 transition-transform duration-300 ${
                                isRTL ? "-scale-x-100 group-hover:-translate-x-0.5" : "group-hover:translate-x-0.5"
                            }`}
                            aria-hidden
                        />
                    </a>
                    <a
                        href="#about"
                        className="inline-flex items-center justify-center h-12 px-7 rounded-full sau-btn-ghost text-sm font-medium tracking-wide w-full sm:w-auto"
                        data-testid="sau-cta-secondary"
                    >
                        {t.cta.secondary}
                    </a>
                </div>
                <p className="sau-reveal mt-5 text-[11.5px] sm:text-[12px] text-[color:var(--sau-muted)]">
                    {t.cta.notice}
                </p>
            </div>
        </section>
    );
}
